export function isChunkLoadError(err: unknown): boolean {
  if (!(err instanceof Error)) return false;
  const msg = err.message ?? "";
  if (msg.includes("Failed to fetch dynamically imported module")) return true;
  if (msg.includes("error loading dynamically imported module")) return true;
  if (msg.includes("Importing a module script failed")) return true;
  if (err.name === "SyntaxError" && /Unexpected token '?<'?/.test(msg))
    return true;
  return false;
}

export function attemptRecoveryReload(): boolean {
  const key = "chunk-reload-at";
  const prev = sessionStorage.getItem(key);
  if (prev !== null && Date.now() - Number(prev) < 60_000) {
    return false;
  }
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
  return true;
}
